import React, { useState,useEffect }  from 'react'
import { Form,  Button,Modal } from 'antd';
import { renderInput, renderTextField } from '../../component/form/form';
import { connect } from 'react-redux';


import { updateScanLimit,getCodeDetails } from '../../actions/code';


  const tailLayout = {
    wrapperCol: { offset: 4, span: 16 },
  };

  
  
  
const EditScanlimit = ({visible, setVisible,code_id,updateScanLimit,getCodeDetails,refresh}) => {
      
      const [data, setData] = useState(null)
     
      const [form] = Form.useForm();

      useEffect(async() => {

        const result = await getCodeDetails(code_id);
        
        setData(result)

            form.setFieldsValue({
              scan_limit: result?.code?.scan_limit
              
            });

      }, [])
    
      const onFinish = async (values) => {
       
        
        const code = await updateScanLimit(values, data?.code?.code_id,'total-scan' )
        if(code === 201){
          refresh()
          setVisible()
        }
      };
    
      const onFinishFailed = (errorInfo) => {
        // console.log('Failed:', errorInfo);
      };
      

      
    return ( 
          
          <Modal
          title="Update Scan Limit"
          centered
          visible={visible}
          onOk={() => setVisible(false)}
          onCancel={() => setVisible(false)}
          width={1000}
        >
          {data ?
              <Form
              name="basic"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              style={{alignSelf: 'center'}}
              requiredMark={false}
              form={form}
              >
                
                {renderInput('scan_limit', 'Set Scan Limit', [
                    { required: true, message: 'This field is required!' },
                  ])
                }
                {renderTextField('remark', 'Remark', [
                  { required: true, message: 'This field is required!' },
                ])
              }
                
                
                <Form.Item {...tailLayout}> 
                  <Button type="primary" htmlType="submit">
                    Update
                  </Button>
                </Form.Item>
              
              </Form>
          :null}
        </Modal>
     );
}
 
export default connect(null,{updateScanLimit,getCodeDetails})(EditScanlimit);
